<section class="cancel-shipment" data-testid="cancel-shipment-page">
  <puro-typography component="h2" variant="h2">
    {{ 'createShipment.getLabels.actions.cancelShipment' | translate }}
  </puro-typography>

  @if (invalidLink()) {
    <app-alert-toast
      severity="error"
      live="assertive"
      [message]="'createShipment.getLabels.cancelError' | translate"
      data-testid="cancel-shipment-invalid-link"
    />
  }

  @if (errorKey(); as errorKey) {
    <app-alert-toast
      severity="error"
      live="assertive"
      [message]="errorKey | translate"
      data-testid="cancel-shipment-error"
    />
  }

  @if (errorKey() || invalidLink()) {
    <puro-button
      type="button"
      variant="primary"
      size="large"
      data-testid="cancel-shipment-home"
      (buttonClick)="onGoHome()"
    >
      {{ 'createShipment.getLabels.cancelledShipment.backToHome' | translate }}
    </puro-button>
  }
</section>

<app-get-labels-cancel-shipment-dialog
  [open]="dialogOpen()"
  [submitting]="submitting()"
  (dismissed)="onDismissed()"
  (confirmed)="onConfirmed()"
/>

@if (trackingPin() && shipmentCreationDate()) {
  <app-get-labels-cancelled-shipment-dialog
    [open]="cancelledDialogOpen()"
    [trackingPin]="trackingPin()"
    [shipmentCreationDate]="shipmentCreationDate()"
    [hasAssociatedPickup]="pickupCancelledOnCancel()"
    (backToHome)="onGoHome()"
  />
}
